export var APIKeysSortField = /*#__PURE__*/ function(APIKeysSortField) {
    APIKeysSortField["Name"] = "name";
    APIKeysSortField["Id"] = "id";
    APIKeysSortField["CreatedOn"] = "created";
    APIKeysSortField["UpdatedOn"] = "updated";
    return APIKeysSortField;
}({});
const SORTABLE_COLUMN_FIELDS = {
    name: "name",
    created: "created",
    updated: "updated"
};
export const toSortField = (columnId)=>{
    var _SORTABLE_COLUMN_FIELDS_columnId;
    return (_SORTABLE_COLUMN_FIELDS_columnId = SORTABLE_COLUMN_FIELDS[columnId]) !== null && _SORTABLE_COLUMN_FIELDS_columnId !== void 0 ? _SORTABLE_COLUMN_FIELDS_columnId : "name";
};
export const formatAPIKeyValue = (keyId)=>"api-key-********".concat(keyId.slice(-4));
const normalizeName = (name)=>name.trim().toLowerCase();
export const getIsNameValid = (param)=>{
    let { name, keys, currentName } = param;
    const trimmedName = normalizeName(name);
    if (currentName != null && trimmedName === normalizeName(currentName)) {
        return true;
    }
    return !keys.some((key)=>normalizeName(key.name) === trimmedName);
};
export const toRows = (keys)=>keys.map((key)=>({
            id: key.id,
            name: key.name,
            value: formatAPIKeyValue(key.id),
            created: new Date(key.createdOn),
            updated: new Date(key.updatedOn)
        }));
